
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('business-sign-up') && (binding.modules['business-sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-business-sign-up' */
            'partner/modules/business-sign-up/business-sign-up.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'business-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/business-sign-up'
    });
        

    isNotRegistered('checkout-delivery-options') && (binding.modules['checkout-delivery-options'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-delivery-options' */
            'partner/modules/checkout-delivery-options/checkout-delivery-options.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'products',  path:'modules/checkout-delivery-options/actions/get-products-details-in-active-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-delivery-options',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-delivery-options'
    });
        

    isNotRegistered('checkout-guest-profile') && (binding.modules['checkout-guest-profile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-guest-profile' */
            'partner/modules/checkout-guest-profile/checkout-guest-profile.tsx'),
        $type: 'contentModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-guest-profile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-guest-profile'
    });
        

    isNotRegistered('cip-back-top-footer') && (binding.modules['cip-back-top-footer'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cip-back-top-footer' */
            'partner/modules/cip-back-top-footer/cip-back-top-footer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-back-top-footer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-back-top-footer'
    });
        

    isNotRegistered('cip-chatbot') && (binding.modules['cip-chatbot'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cip-chatbot' */
            'partner/modules/cip-chatbot/cip-chatbot.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-chatbot',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-chatbot'
    });
        

    isNotRegistered('cip-checkout-customer-account-payment') && (binding.modules['cip-checkout-customer-account-payment'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cip-checkout-customer-account-payment' */
            'partner/modules/cip-checkout-customer-account-payment/cip-checkout-customer-account-payment.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'creditBalances',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-checkout-customer-account-payment',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-checkout-customer-account-payment'
    });
        

    isNotRegistered('cip-cta-link') && (binding.modules['cip-cta-link'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cip-cta-link' */
            'partner/modules/cip-cta-link/cip-cta-link.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-cta-link',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-cta-link'
    });
        

    isNotRegistered('cip-product-specification') && (binding.modules['cip-product-specification'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cip-product-specification' */
            'partner/modules/cip-product-specification/cip-product-specification.tsx'),
        $type: 'contentModule',
        da: [{name:'additionalMediaLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-additional-media-locations-for-selected-variant', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-product-specification',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-product-specification'
    });
        

    isNotRegistered('cip-quick-link') && (binding.modules['cip-quick-link'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cip-quick-link' */
            'partner/modules/cip-quick-link/cip-quick-link.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-quick-link',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-quick-link'
    });
        

    isNotRegistered('cip-quick-order') && (binding.modules['cip-quick-order'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cip-quick-order' */
            'partner/modules/cip-quick-order/cip-quick-order.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'cartConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'cip-quick-order',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cip-quick-order'
    });
        

    isNotRegistered('master') && (binding.modules['master'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-master' */
            'partner/themes/master/master.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['active-image','b2b-requests-status','business-organization-list','buybox','cart-icon','cart','content-block','header','image-list','navigation-menu','order-details','order-template-list','promo-banner','quickview','ratings-histogram','reviews-list','search-result-container','search','sign-in','site-picker','store-selector','text-block','write-review'],
        iNM: false,
        ns: '__local__',
        n: 'master',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'master.theme.settings.json',
        md: 'src/themes/master'
    });
        

    isNotRegistered('order-template') && (binding.modules['order-template'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-template' */
            'partner/modules/order-template/order-template.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplate',  path:'modules/order-template/actions/get-order-template', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'order-template',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/order-template'
    });
        

    isNotRegistered('product-collection') && (binding.modules['product-collection'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-collection' */
            'partner/modules/product-collection/product-collection.tsx'),
        $type: 'containerModule',
        da: [{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'product-collection',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-collection'
    });
        

    isNotRegistered('search-result-container') && (binding.modules['search-result-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-search-result-container' */
            'partner/modules/search-result-container/search-result-container.tsx'),
        $type: 'containerModule',
        da: [{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'featureProduct',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'listPageState',  path:'modules/search-result-container/list-page-state', runOn: 0},{name:'products',  path:'modules/search-result-container/actions/get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'modules/search-result-container/actions/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'modules/search-result-container/actions/get-mapped-search-configuration', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'search-result-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/search-result-container'
    });
        

        {   
            const actionPath = 'actions/get-device-details.action';
            binding.dataActions[actionPath] = require('partner/actions/get-device-details.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-devices.action';
            binding.dataActions[actionPath] = require('partner/actions/get-devices.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-graduated-price.action';
            binding.dataActions[actionPath] = require('partner/actions/get-graduated-price.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-availabilities-for-selected-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-availabilities-for-selected-variant.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-v-articles.action';
            binding.dataActions[actionPath] = require('partner/actions/get-v-articles.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/knowledgebase/get-knowledgebase-article-details.action';
            binding.dataActions[actionPath] = require('partner/actions/knowledgebase/get-knowledgebase-article-details.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/knowledgebase/get-knowledgebase-articles.action';
            binding.dataActions[actionPath] = require('partner/actions/knowledgebase/get-knowledgebase-articles.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/service-ticket/cancel-service-ticket.action';
            binding.dataActions[actionPath] = require('partner/actions/service-ticket/cancel-service-ticket.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/service-ticket/create-service-ticket.action';
            binding.dataActions[actionPath] = require('partner/actions/service-ticket/create-service-ticket.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/service-ticket/get-service-ticket-detail.action';
            binding.dataActions[actionPath] = require('partner/actions/service-ticket/get-service-ticket-detail.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/service-ticket/get-service-tickets.action';
            binding.dataActions[actionPath] = require('partner/actions/service-ticket/get-service-tickets.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/service-ticket/post-extend-warranty.action';
            binding.dataActions[actionPath] = require('partner/actions/service-ticket/post-extend-warranty.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-delivery-options')){
            const sanitizedActionPath = 'modules/checkout-delivery-options/actions/get-products-details-in-active-checkout-cart';
            let dataAction = require('partner/modules/checkout-delivery-options/actions/get-products-details-in-active-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-guest-profile')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-guest-profile')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-guest-profile')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-checkout-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-checkout-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-checkout-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-product-specification')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-product-specification')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-additional-media-locations-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-additional-media-locations-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-product-specification')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-quick-order')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-quick-order')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-quick-order')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cip-quick-order')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-template')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-template')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-template')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('order-template')){
            const sanitizedActionPath = 'modules/order-template/actions/get-order-template';
            let dataAction = require('partner/modules/order-template/actions/get-order-template');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-collection')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')){
            const sanitizedActionPath = 'modules/search-result-container/actions/get-full-products-by-collection';
            let dataAction = require('partner/modules/search-result-container/actions/get-full-products-by-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')){
            const sanitizedActionPath = 'modules/search-result-container/actions/get-mapped-search-configuration';
            let dataAction = require('partner/modules/search-result-container/actions/get-mapped-search-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')){
            const sanitizedActionPath = 'modules/search-result-container/actions/get-refiners-for-collection';
            let dataAction = require('partner/modules/search-result-container/actions/get-refiners-for-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('search-result-container')){
            const sanitizedActionPath = 'modules/search-result-container/list-page-state';
            let dataAction = require('partner/modules/search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};